export interface SliderThemeProps {
    base: string;
    input: string;
    range: string;
    bar: string;
    innerBar: string;
    handle: {
        base: string;
        left: string;
        right: string;
    };
    label: string;
}

export const sliderTheme: SliderThemeProps = {
    base: 'flex p-2 w-full justify-center',
    input: 'absolute appearance-none opacity-0 w-6 h-6 z-50 -top-2',
    bar: 'absolute left-0 right-0 bottom-0 top-0 rounded-md bg-gray-300 dark:bg-gray-600',
    innerBar: 'absolute z-20 top-0 bottom-0 rounded-md bg-gray-800 dark:bg-gray-50',
    range: 'relative h-2',
    handle: {
        base: 'absolute z-30 w-6 h-6 top-0 bg-white rounded-full -mt-2 shadow border-2 border-gray-800 dark:bg-catapult-grey-900 dark:border-gray-50',
        left: 'left-0 -ml-1',
        right: 'right-0 -mr-3',
    },
    label: 'flex justify-between items-center py-5 text-gray-700 dark:text-gray-300',
};
